<svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24">
  <path
    fill="currentColor"
    d="M12 3 2 8v13h7v-6h6v6h7V8zm-8 9H2V9.8l10-5.3 10 5.3V12h-2v-2.3l-6-3.2V9h-4v2.3l-6-3.2V12z" />
</svg>
